import Image from "@components/common/OldCloudinaryImage";
import React from "react";
import { cn } from "../../utils/cn";

const Banner = ({ filename, title, subtitle, className }) => {
    return (
        <div className={cn("relative h-[46rem] bg-gray-400", className)}>
            {/** Será la capa de fondo */}
            <div className="pointer-events-none absolute inset-0 z-0 h-full w-full bg-ccyan-dark">
                <Image
                    filename={filename}
                    className="h-full w-full object-cover"
                />
            </div>

            {/** Overlay */}
            <div className="pointer-events-none absolute inset-0 z-10 h-full w-full bg-gradient-to-b from-black/80 via-black/20 to-black/80" />

            {/** Overlay 2 */}
            <div className="pointer-events-none absolute inset-0 z-20 h-full w-full bg-hero-pattern bg-repeat opacity-75" />

            {/** Content */}
            <div className="relative z-30 h-full">
                <div className="container flex h-full items-end pb-20 sm:pb-24 md:pb-32">
                    <div className="font-roboto flex flex-col lg:max-w-4xl">
                        <h1 className="text-shadow-2xs order-1 mt-5 text-balance text-3xl font-bold uppercase leading-tight tracking-wide text-white lg:text-6xl lg:tracking-widest">
                            {title}
                        </h1>

                        <h2 className="text-shadow-2xs order-2 mt-5 text-2xl font-bold uppercase tracking-wide text-white lg:text-3xl lg:tracking-widest">
                            {subtitle}
                        </h2>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Banner;
